<script lang="ts">
  import { onMount } from "svelte"
  import Layout from "$app/Layouts/University.svelte"
  import StepNavigation from "../StepNavigation.svelte"
  import Show from "./Show.svelte"
  import Modal from "$app/components/Modal.svelte"
  import PurchaseCourse from "../PurchaseCourse.svelte"
  import PreviewCourse from "../PreviewCourse.svelte"
  import { appStore } from "$app/store.svelte"

  interface Props {
    course: CourseType
    course_progress: CourseProgressType
    stripe_publish_key: string
    stripe_product: string
  }
  let props = $props()
  let { course, stripe_publish_key, stripe_product }: Props = props

  let course_progress: CourseProgressType = $state(props.course_progress)

  appStore.course = course

  onMount(async () => {
    if (!course_progress.purchased) {
      openPreviewModal = true
    }
  })

  let openPurchaseModal = $state(false)
  let openPreviewModal = $state(false)

  function purchaseCourse() {
    openPurchaseModal = true
  }

  function updateProgress(data) {
    course_progress = data

    openPurchaseModal = false

    var newURL = location.href.split("?")[0]
    window.history.pushState("object", document.title, newURL)
  }
</script>

<Layout {...props}>
  <div class="h-screen flex overflow-hidden bg-course-bg-light">
    <div class="flex flex-shrink-0 my-4 ml-6 overflow-y-auto">
      <StepNavigation
        bind:course_progress
        {purchaseCourse}
        onUpdateProgress={updateProgress}
      />
    </div>
    <div class="flex flex-col w-0 flex-1 overflow-hidden">
      <main
        class="flex shadow-lg relative z-0 overflow-y-auto focus:outline-none bg-white rounded-tl rounded-tr rounded-br my-4 mr-6"
      >
        <Show
          {course_progress}
          {purchaseCourse}
          onUpdateProgress={updateProgress}
        />
      </main>
    </div>
  </div>
</Layout>

<Modal closeOnOuterClick={true} bind:open={openPreviewModal}>
  <PreviewCourse {course} />
</Modal>

<Modal closeOnOuterClick={true} bind:open={openPurchaseModal} large={true}>
  <PurchaseCourse
    {stripe_publish_key}
    {stripe_product}
    onUpdateProgress={updateProgress}
  />
</Modal>
